document.addEventListener('DOMContentLoaded', function () {
  (function initCoveoShowLessHider() {
    // Track one shadow observer per facet so we can disconnect when facets are removed.
    const facetShadowObservers = new WeakMap();

    const isFacetNode = (node) =>
      node && node.nodeType === 1 && node.localName === 'atomic-commerce-facet';

    const disconnectFacetObserver = (facetNode) => {
      const shadowObserver = facetShadowObservers.get(facetNode);
      if (!shadowObserver) return;

      shadowObserver.disconnect();
      facetShadowObservers.delete(facetNode);
    };

    const hideShowLessButton = (shadowRoot) => {
      if (!shadowRoot) return;

      const showMore = shadowRoot.querySelector('[part="show-more"]');
      const showLess = shadowRoot.querySelector('[part="show-less"]');

      if (!showLess) return;

      const showMoreDisplayed =
        !!showMore && window.getComputedStyle(showMore).display !== 'none';
      const showLessDisplayed =
        window.getComputedStyle(showLess).display !== 'none';

      if (showMoreDisplayed && showLessDisplayed) {
        showLess.style.display = 'none';
      } else if (!showMoreDisplayed && showLess.style.display === 'none') {
        // Revert visibility when Show More is hidden/not displayed.
        showLess.style.display = '';
      }
    };

    const attachShadowObserver = (node) => {
      if (isFacetNode(node)) {
        if (facetShadowObservers.has(node)) return;

        customElements.whenDefined('atomic-commerce-facet').then(() => {
          if (node.shadowRoot) {
            hideShowLessButton(node.shadowRoot);

            // Attach a dedicated observer to the shadowRoot since the main DOM cannot see internal component updates.
            const shadowObserver = new MutationObserver(() => hideShowLessButton(node.shadowRoot));
            shadowObserver.observe(node.shadowRoot, { childList: true, subtree: true });
            facetShadowObservers.set(node, shadowObserver);
          }
        });
      }
    };

    // Scope the observer strictly to the facet container to maximize performance.
    const facetContainer = document.querySelector('atomic-commerce-facets');

    if (facetContainer) {
      Array.from(facetContainer.children)
        .filter(isFacetNode)
        .forEach(attachShadowObserver);

      const scopedObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            for (const node of mutation.addedNodes) {
              if (isFacetNode(node)) {
                attachShadowObserver(node);
              }
            }

            for (const node of mutation.removedNodes) {
              if (isFacetNode(node)) {
                disconnectFacetObserver(node);
              }
            }
          }
        }
      });

      scopedObserver.observe(facetContainer, { childList: true });
    }
  })();
});